<template>
  <div class="eu-pb_5">
    <div class="emd-container _highlight_header">
      <div class="emd-container__header">
        <PaymentMethodTitle />
      </div>

      <div class="eu-pa_3">
        <LastTransactionInfos
          :payment-method="treatedPaymentMethod"
          :last-transaction-id="lastTransaction.id"
          :last-transaction-card="lastTransaction.card"
        />
      </div>

      <PaymentCards
        v-if="hasPaymentCards"
        :last-transaction-id="lastTransaction.id"
        :last-transaction-card="lastTransaction.card"
        :installments="lastTransaction.installments"
        :merchant-id="merchantId"
        :account-id="accountId"
        :customer-id="customerId"
      />
      <section
        v-else
        class="emd-card-grid"
      >
        <Boleto
          v-if="hasBoleto"
          :last-transaction="lastTransaction"
        />

        <BankTransfer
          v-if="hasBankTransfer"
          :last-transaction="lastTransaction"
          :due-at="charge.due_at"
        />

        <Cash
          v-if="hasCash"
          :last-transaction="lastTransaction"
        />

        <SafetyPay
          v-if="hasSafetyPay"
          :last-transaction="lastTransaction"
        />

        <Pix
          v-if="hasPix"
          :charge-id="charge.id"
          :transactions="charge.transactions"
        />
      </section>
    </div>
  </div>
</template>

<script>
import {
  isCardsOrVoucher,
  isBoleto,
  isCash,
  isSafetyPay,
  isPix,
  isBankTransfer,
  isPrepaid
} from '@/enums/payment-method.enum'

export default {
  name: 'ChargesPaymentMethod',
  components: {
    PaymentMethodTitle: () =>
      import(
        /* webpackChunkName: "payment-method-title" */ './components/PaymentMethodTitle.vue'
      ),
    LastTransactionInfos: () =>
      import(
        /* webpackChunkName: "last-transaction-infos" */ './components/LastTransactionInfos.vue'
      ),
    PaymentCards: () =>
      import(
        /* webpackChunkName: "payment-cards-and-voucher-and-private-label" */ './features/PaymentCards'
      ),
    BankTransfer: () =>
      import(/* webpackChunkName: "bank-transfer" */ './features/BankTransfer'),
    Boleto: () => import(/* webpackChunkName: "boleto" */ './features/Boleto'),
    Cash: () => import(/* webpackChunkName: "cash" */ './features/Cash'),
    SafetyPay: () =>
      import(/* webpackChunkName: "safety-pay" */ './features/SafetyPay'),
    Pix: () => import(/* webpackChunkName: "pix" */ './features/Pix')
  },
  props: {
    charge: {
      type: Object,
      required: true
    },
    merchantId: {
      type: String,
      default: ''
    },
    accountId: {
      type: String,
      default: ''
    }
  },

  computed: {
    customerId () {
      return this.charge.customer.id
    },
    paymentMethod () {
      return this.charge.payment_method
    },
    lastTransaction () {
      return this.charge.last_transaction
    },
    hasPaymentCards () {
      return isCardsOrVoucher(this.paymentMethod)
    },
    hasBoleto () {
      return isBoleto(this.paymentMethod)
    },
    hasBankTransfer () {
      return isBankTransfer(this.paymentMethod)
    },
    hasCash () {
      return isCash(this.paymentMethod)
    },
    hasSafetyPay () {
      return isSafetyPay(this.paymentMethod)
    },
    hasPix () {
      return isPix(this.paymentMethod)
    },
    treatedPaymentMethod () {
      if (!isPrepaid(this.charge.transactions?.[0])) return this.paymentMethod
      return `${this.paymentMethod} ${this.charge.last_transaction.funding_source}`
    }
  }
}
</script>

<style>
.emd-card-grid__row {
  padding: 0;
}

.emd-card-grid__column {
  border: none;
  padding: 12px;
}

.emd-card-grid {
  padding-bottom: 0;
}

._mode_dark .emd-card-grid,
._mode_light .emd-card-grid,
.emd-card-grid {
  border: none;
}

._mode_dark .emd-card-grid .emd-card-grid__line,
._mode_light .emd-card-grid .emd-card-grid__line,
.emd-card-grid .emd-card-grid__line {
  border: none;
}
</style>
